module.exports = __webpack_public_path__ + "static/img/bg-overview@m.6ea6eb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-life-science/bg-overview@m.jpg
// module id = g7W8
// module chunks = 0